import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const buttonWidth = Theme.BU * 11;
const iconSize = 24;
const baseStyles = StyleSheet.create({
    button: {
        position: 'relative',
        height: 55,
        flexDirection: 'row',
        alignSelf: 'stretch',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        backgroundColor: Theme.primaryButtonBackgroundColor,
        borderRadius: 3,
        borderColor: Theme.primaryButtonBorderColor,
        borderWidth: 2,
        paddingHorizontal: Theme.BU,
        minWidth: buttonWidth
    },
    textContainerWithoutIcon: {
        flex: 50,
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
    },
    textContainer: {
        flex: 50,
        height: '100%',
        justifyContent: 'center',
        paddingRight: iconSize
    },
    mainText: {
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: Theme.fontSizes.button,
        paddingTop: 2
    },
    iconContainer: {
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        width: iconSize,
        marginRight: 12
    },
    icon: {
        width: iconSize,
        height: iconSize,
        marginRight: 12
    },
    secondaryButtonStyle: {
        borderWidth: 1,
        borderColor: Theme.secondaryButtonBorderColor,
        backgroundColor: Theme.secondaryButtonBackgroundColor,
        borderRadius: 4
    }
});

export default baseStyles;
